import React from 'react';
import _ from 'lodash';
import axios from 'axios';

function useEventsApi(env) {
  const endpoints = {
    events_api_events_settings: {
      en: env.REACT_APP_EVENTS_SETTINGS_EN || env.REACT_APP_BASEURL_EN + '/api/v1/settings/events',
      cy: env.REACT_APP_EVENTS_SETTINGS_CY || env.REACT_APP_BASEURL_CY + '/api/v1/settings/events'
    },
    events_api_events: {
      en: env.REACT_APP_EVENTS_EN || env.REACT_APP_BASEURL_EN + '/api/v1/events',
      cy: env.REACT_APP_EVENTS_CY || env.REACT_APP_BASEURL_CY + '/api/v1/events'
    }
  };

  function getEndpoint(name) {
    return endpoints[name];
  }

  async function getSettings(language, successCallback, errorCallback) {
    return axios
      .get(`${endpoints.events_api_events_settings[language]}`, {
        params: {
          time: Date.now()
        }
      })
      .then((response) => {
        successCallback(response);
        return response;
      })
      .catch((error) => {
        errorCallback(error);
        return error.response;
      });
  }

  /**
   * eventsApiGetVenue
   * @param id
   * @param language
   * @param successCallback
   * @param errorCallback
   */
  async function getEvents(domain, language, successCallback, errorCallback) {
    return axios
      .get(`${endpoints.events_api_events[language]}`, {
        params: {
          domain: domain,
          time: Date.now()
        }
      })
      .then((response) => {
        successCallback(response);
        return response;
      })
      .catch((error) => {
        errorCallback(error);
        return error.response;
      });
  }

  function getEvent(event, language, successCallback, errorCallback) {
    return axios
      .get(`${endpoints.events_api_events[language]}` + '/' + event, {
        params: {
          time: Date.now()
        }
      })
      .then((response) => {
        successCallback(response);
        return response;
      })
      .catch((error) => {
        errorCallback(error);
        return error.response;
      });
  }

  function sortAlphaName(data) {
    return data.sort((a, b) => a.name.localeCompare(b.name));
  }

  function lookupValue(data, value, type = 'name') {
    let response = _.find(data, ['value', value]);
    if (response) {
      if (type == 'name') {
        return response.name;
      } else {
        return response.description;
      }
    }
    return null;
  }

  return {
    getEndpoint,
    getSettings,
    getEvents,
    getEvent,
    sortAlphaName,
    lookupValue
  };
}

export default useEventsApi;
